module.exports = "https://wrf-static.prod-my.games/promo/long-lp/img/steam.f95c415d.svg";